module.exports = __webpack_public_path__ + "img/doc-live-streaming.b6bd78dd.png";